<template>
  <div class="template-connected">
    <div id="container">
      <b-row>
        <b-col cols="12" sm="12" md="12" lg="12" xl="12">
          <div class="block-flat">
            <div class="block-content">
              <fieldset>
                <legend v-if="this.$route.params.type == 'operator'">
                  Operateurs
                </legend>
                <legend v-if="this.$route.params.type == 'soustraitant'">
                  Sous traitants
                </legend>
                <div class="form-group">
                  <b-row>
                    <b-col
                      cols="12"
                      sm="12"
                      md="9"
                      lg="9"
                      xl="9"
                      class="no-padding"
                    >
                      <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Rechercher..."
                      ></b-form-input>
                    </b-col>
                    <b-col
                      cols="12"
                      sm="12"
                      md="3"
                      lg="3"
                      xl="3"
                      class="marginTopSmall"
                    >
                      <b-button
                        @click="
                          add = true;
                          scrollToAdd();
                        "
                        variant="success"
                        style="width:100%;line-height:20px;"
                      >
                        Ajouter
                      </b-button>
                    </b-col>
                  </b-row>
                </div>
                <b-table
                  :filter="filter"
                  selectable
                  :show-empty="true"
                  empty-filtered-text="Pas de groupe"
                  empty-text="Pas de groupe"
                  responsive
                  :select-mode="'single'"
                  striped
                  :tbody-tr-class="'table-groups'"
                  bordered
                  @row-selected="onRowSelected"
                  hover
                  head-variant="dark"
                  :items="perimeters"
                  :fields="fields"
                >
                  <template v-slot:cell(selected)="{ rowSelected }">
                    <template v-if="rowSelected">
                      <span aria-hidden="true">&check;</span>
                      <span class="sr-only">Selected</span>
                    </template>
                    <template v-else>
                      <span aria-hidden="true">&nbsp;</span>
                      <span class="sr-only">Not selected</span>
                    </template>
                  </template>
                  <template v-slot:cell(id)="{ item }">
                    <b-button
                      v-b-tooltip.hover
                      title="Supprimer la zone"
                      @click="askdelete(item)"
                      variant="danger"
                    >
                      <font-awesome-icon icon="trash-alt"></font-awesome-icon>
                    </b-button>
                  </template>
                </b-table>
              </fieldset>
            </div>
          </div>
        </b-col>
        <b-col cols="12" sm="12" md="12" lg="12" xl="12" id="addBlock">
          <div v-if="add == true || edit == true">
            <div class="block-flat">
              <div class="block-content">
                <fieldset>
                  <legend v-if="add == true">Ajout</legend>
                  <legend v-if="edit == true">Modification</legend>
                  <div class="form-group">
                    <b-row>
                      <b-col lg="3" md="4" sm="12" cols="12">
                        <label class="control-label">Nom :</label>
                      </b-col>
                      <b-col lg="9" md="6" sm="12" cols="12">
                        <b-form-input
                          v-model="perimeter.libelle"
                          placeholder="Merci de renseigner le nom"
                        ></b-form-input>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col lg="3" md="4" sm="12" cols="12">
                        <label class="control-label">Siret :</label>
                      </b-col>
                      <b-col lg="9" md="6" sm="12" cols="12">
                        <b-form-input
                          v-model="perimeter.code"
                          placeholder="Merci de renseigner le siret"
                        ></b-form-input>
                      </b-col>
                    </b-row>
                    <b-row v-if="this.$route.params.type == 'operator'">
                      <b-col
                        lg="12"
                        md="12"
                        sm="12"
                        cols="12"
                        class="form-with-label"
                      >
                        <b-form-radio-group
                          v-model="perimetersManagerSelected"
                          :options="perimetres"
                          class="mb-3 popup-custom-checkbox"
                          value-field="value"
                          text-field="text"
                        ></b-form-radio-group>
                      </b-col>
                      <b-col
                        lg="12"
                        md="12"
                        sm="12"
                        cols="12"
                        class="form-with-label"
                      >
                        <autocomplete
                          ref="autocomplete"
                          @selected="addToTab"
                          :disableInput="perimetersManagerSelected == null"
                          :class="
                            perimetersManagerSelected == null ? 'disabled' : ''
                          "
                          results-property="data"
                          :request-headers="{ Authorization: token }"
                          :source="
                            urlapi +
                              'perimeter?limit=10&type=' +
                              perimetersManagerSelected +
                              '&q='
                          "
                          resultsValue="id"
                          placeholder="Recherche..."
                          resultsDisplay="libelle"
                          input-class="form-control"
                        >
                          <template v-slot:noResults>
                            Pas de résultat
                          </template>
                        </autocomplete>
                        <!-- <b-form-select v-model="userSelected.managerPerimeterId"  value-field="id" text-field="libelle" :options="perimetersManager"></b-form-select> -->
                      </b-col>
                    </b-row>
                    <b-row v-if="this.$route.params.type == 'operator'">
                      <b-col cols="12">
                        <b-table
                          selectable
                          responsive
                          :select-mode="'single'"
                          striped
                          bordered
                          :show-empty="true"
                          empty-text="Pas de périmètre ajouté"
                          hover
                          head-variant="dark"
                          :items="perimeter.perimeters"
                          :fields="fieldsPerimeter"
                        >
                          <template v-slot:cell(type)="{ value }">
                            <span v-if="value == 'town'">Ville</span>
                            <span v-if="value == 'epci'">Epci</span>
                            <span v-if="value == 'department'"
                              >Département</span
                            >
                          </template>
                          <template v-slot:cell(id)="{ index }">
                            <b-button
                              v-b-tooltip.hover
                              title="Supprimer le périmetre"
                              @click="deleteCompPerimeter(index)"
                              variant="danger"
                            >
                              <font-awesome-icon
                                icon="trash-alt"
                              ></font-awesome-icon>
                            </b-button>
                          </template>
                        </b-table>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col class="text-center" cols="12" md="6" lg="6" xl="6">
                        <b-button @click="save" variant="success"
                          >Enregistrer</b-button
                        >
                      </b-col>
                      <b-col class="text-center" cols="12" md="6" lg="6" xl="6">
                        <b-button @click="cancel" variant="danger"
                          >Annuler</b-button
                        >
                      </b-col>
                    </b-row>
                  </div>
                </fieldset>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import Vuex from "vuex";
import Vue from "vue";
export default {
  name: "Operateur",
  data() {
    return {
      urlapi: window.urlapi,
      perimetersManagerSelected: null,
      perimetres: [
        { value: "department", text: "Département" },
        { value: "epci", text: "EPCI" },
        { value: "town", text: "Commune" },
      ],
      edit: false,
      add: false,
      perimeter: {
        libelle: "",
        perimeters: [],
        type: this.$route.params.type,
      },
      filter: "",
      selected: null,
      fieldsPerimeter: [
        {
          key: "libelle",
          sortable: true,
          label: "Nom",
        },
        {
          key: "type",
          sortable: true,
          label: "Type",
        },
        {
          key: "id",
          sortable: false,
          label: "Actions",
        },
      ],
      fields: [
        {
          key: "libelle",
          sortable: true,
          label:
            this.$route.params.type == "operator"
              ? "Nom de l'opérateur"
              : "Nom du sous traitant",
        },
        {
          key: "id",
          sortable: false,
          label: "Actions",
        },
      ],
    };
  },
  beforeMount() {
    this.getPerimeters({ type: this.$route.params.type });
  },
  methods: {
    askdelete(item) {
      Vue.prototype.$awn.confirm(
        "Voulez vous vraiment supprimer cet opérateur ?",
        () => {
          this.deletePerimeter(item.id);
        },
        () => {}
      );
    },
    deleteCompPerimeter(index) {
      this.perimeter.perimeters.splice(index, 1);
    },
    save() {
      if (this.add == true) {
        this.addPerimeter(this.perimeter);
        this.cancel();
      }
    },
    cancel() {
      this.edit = false;
      this.add = false;
      this.perimeter = {
        libelle: "",
        perimeters: [],
        type: this.$route.params.type,
      };
    },
    addToTab(data) {
      this.perimeter.perimeters.push(data.selectedObject);
      this.$refs.autocomplete.clear();
    },
    onRowSelected(items) {
      this.selected = items;
    },
    scrollToAdd() {
      var el = this.$el.querySelector("#addBlock");
      el.scrollIntoView({ behavior: "smooth" });
    },
    ...Vuex.mapActions("Perimeter", [
      "getPerimeters",
      "addPerimeter",
      "deletePerimeter",
    ]),
  },
  computed: {
    ...Vuex.mapGetters("Perimeter", ["perimeters"]),
    ...Vuex.mapGetters("Authentification", ["token"]),
  },
};
</script>

<style></style>
